import { useContext, useEffect, useState } from 'react';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { awsDriverFileURL, formattedMonth } from '../../../contexts/utils';

export const DriverInfoModal = ({ driver, closeModal }) => {
  const [innerModal, setInnerModal] = useState(false);
  const [selected, setSelected] = useState(false);

  const {
    loading,
    deleteDriver,
    approveDriver,
    changeDriverCarType,
    success,
    setGlobalError,
  } = useContext(DashboardContext);

  const handleSelection = (e) => {
    e.preventDefault();
    if (selected) changeDriverCarType(driver.carId, selected);
    else setGlobalError('No car type is selected');
  };

  const toggleInnerModal = (close) => {
    if (close) return setInnerModal(false);

    setInnerModal(!innerModal);
  };

  useEffect(() => {
    if (success) toggleInnerModal(true);

    // eslint-disable-next-line
  }, [success]);

  return (
    <div className='info-modal-con'>
      <div className='header'>
        <div className='car-cover-img'>
          <img
            src={`${awsDriverFileURL}${driver.carImage}`}
            alt={`${driver.carName} img`}
          />
        </div>
        <div className='driver-img'>
          <img
            src={`${awsDriverFileURL}${driver.image}`}
            alt={`${driver.name} img`}
          />
        </div>
        <p className='cncl-btn' onClick={closeModal}>
          &times;
        </p>
      </div>
      <div className='main-info'>
        <p className='username'>{driver.name}</p>
        <ul>
          <li>
            <p className='thick'>Car Name</p>
            <p>{driver.carName}</p>
          </li>
          <li>
            <p className='thick'>Car Type</p>
            <p className='link_text' onClick={() => toggleInnerModal(false)}>
              {driver.carType?.substr(0, 1).toUpperCase() +
                driver.carType?.substr(1)}
            </p>
          </li>
          <li>
            <p className='thick'>Plate No.</p>
            <p>{driver.carId?.toUpperCase()}</p>
          </li>
          <li>
            <p className='thick'>Phone No.</p>
            <p>{driver.phoneNum}</p>
          </li>

          <li>
            <p className='thick'>Status</p>
            <p className='status'>
              <i
                style={{
                  backgroundColor:
                    driver.status === 'pending' ? 'tomato' : '#3caf50',
                }}
              ></i>
              {`${
                driver.status?.substr(0, 1).toUpperCase() +
                driver.status?.substr(1)
              }`}
            </p>
          </li>
        </ul>
        {driver.status === 'approved' && (
          <div>
            <p className='username'>More Info</p>
            <ul>
              <li>
                <p className='thick'>Stars</p>
                <p>
                  <i
                    className='fas fa-star'
                    style={{ fontSize: 13, paddingRight: 5, color: 'gold' }}
                  ></i>
                  {driver.stars?.starReceived}/{driver.stars?.overall}
                </p>
              </li>
              <li>
                <p className='thick'>All Rides</p>
                <p>
                  <i
                    className='fas fa-car'
                    style={{ fontSize: 13, paddingRight: 5, color: '#c939ba' }}
                  ></i>
                  {driver.completedRides}
                </p>
              </li>
              <li>
                <p className='thick'>{formattedMonth}'s Rides</p>
                <p>
                  <i
                    className='fas fa-car'
                    style={{ fontSize: 13, paddingRight: 5, color: '#3caf50' }}
                  ></i>
                  {driver.ridesThisMonth}
                </p>
              </li>
              <li>
                <p className='thick'>Today's Rides</p>
                <p>
                  <i
                    className='fas fa-car'
                    style={{ fontSize: 13, paddingRight: 5, color: '#457dea' }}
                  ></i>
                  {driver.ridesToday}
                </p>
              </li>
              <li>
                <p className='thick'>Date Joined</p>
                <p>
                  <i
                    className='fas fa-calendar'
                    style={{ fontSize: 13, paddingRight: 5 }}
                  ></i>
                  {driver.createdAt}
                </p>
              </li>
            </ul>
          </div>
        )}
        {driver.status === 'pending' ? (
          <div className='actions'>
            <button
              onClick={() => approveDriver(driver.carId)}
              disabled={loading}
            >
              {loading ? 'loading...' : 'Approve'}
            </button>
            <button
              className='delete'
              onClick={() => deleteDriver(driver.carId)}
              disabled={loading}
            >
              {loading ? 'loading...' : 'Delete'}
            </button>
          </div>
        ) : (
          <button
            className='delete single'
            onClick={() => deleteDriver(driver.carId)}
            disabled={loading}
          >
            {loading ? 'loading...' : 'Remove Driver'}
          </button>
        )}
      </div>
      <div className={`inner-modal ${innerModal && 'active'}`}>
        <h3>Change Car Type</h3>
        <p>
          Choose a new car type for {driver.name}: {driver.carType}
        </p>
        <form onSubmit={handleSelection}>
          <div>
            <input
              type='radio'
              name='carType'
              value='Luxury'
              id='luxury'
              onChange={() => setSelected('luxury')}
            />
            <label htmlFor='luxury'>Luxury</label>
          </div>
          <div>
            <input
              type='radio'
              name='carType'
              value='Premium'
              id='premium'
              onChange={() => setSelected('premium')}
            />
            <label htmlFor='premium'>Premium</label>
          </div>
          <div className='buttons'>
            <input
              type='submit'
              value={loading ? 'loading...' : 'Update'}
              onClick={handleSelection}
            />
            <button
              onClick={() => toggleInnerModal(false)}
              type='button'
              style={{ background: 'tomato', color: '#fff' }}
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
